<div mdbModal #editarPesoVolumen="mdb-modal" class="modal fade" id="basicExamplex" tabindex="-1" role="dialog"
    aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
    <div class="modal-dialog modal-sm" role="document">
        <div class="modal-content">
            <form [formGroup]="formPesoVolumen" (ngSubmit)="guardarPesoVolumen();">
                <div class="modal-header">
                    <h4 class="modal-title w-100 text-left" id="myModalLabel">Editar Peso y Volumen</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                        (click)="editarPesoVolumen.hide()"><span aria-hidden="true">×</span></button>
                </div>
                <div class="modal-body">
                    <div class="container">
                        <div class="row">
                            <div class="col">
                                <div class="md-form">
                                    <input value="" formControlName="peso" type="number" id="ppeso" class="form-control"
                                        placeholder="Peso (Kgs.)" maxLength="6" step="0.1" #ppeso />
                                    <label for="ppeso">Peso <span class="text-danger"></span></label>
                                </div>
                                
                            </div>
                            
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="md-form">
                                    <input value="" formControlName="volumen" type="number" id="pvolumen" class="form-control"
                                        placeholder="Volumen (m3)" maxLength="50" step="0.1" #pvolumen />
                                    <label for="pvolumen">Volumen <span class="text-danger"></span></label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button" class="btn btn-sm btn-default waves-light" size="sm" data-dismiss="modal"
                        (click)="editarPesoVolumen.hide()" mdbWavesEffect>Cerrar</button>
                    <button type="submit" class="btn btn-sm btn-default waves-light" size="sm" data-dismiss="modal"
                        mdbWavesEffect>Guardar</button>
                </div>
            </form>
        </div>
    </div>
</div>